import React from 'react'

type Option<T extends string> = { value: T; label: string }

type SegmentedProps<T extends string> = {
  options: Option<T>[]
  value: T
  onChange: (value: T) => void
}

export function Segmented<T extends string>({ options, value, onChange }: SegmentedProps<T>) {
  return (
    <div className="flex items-center bg-surface-3 dark:bg-surface-2 rounded-[8px] p-0.5 gap-0.5">
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          onClick={() => onChange(o.value)}
          className={[
            'px-3 py-1.5 text-sm rounded-[6px] transition-colors',
            value === o.value
              ? 'active bg-surface dark:bg-surface-3 text-text font-medium shadow-sm'
              : 'text-text-2 hover:text-text-4',
          ].join(' ')}
        >
          {o.label}
        </button>
      ))}
    </div>
  )
}
